
    const data = {"name":"src/core/icons/message-processing","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M17 11h-2V9h2m-4 2h-2V9h2m-4 2H7V9h2m11-7H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            